import { memo } from 'react';

import type { IconProps } from './types';
import BaseIcon from './BaseIcon';

export default memo((props: IconProps) => {
    return (
        <BaseIcon viewBox="0 0 16 16" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0.774194C0 0.346618 0.307005 0 0.685714 0H15.3143C15.693 0 16 0.346618 16 0.774194C16 1.20177 15.693 1.54839 15.3143 1.54839H0.685714C0.307005 1.54839 0 1.20177 0 0.774194ZM0 5.5914C0 5.16382 0.307005 4.8172 0.685714 4.8172H15.3143C15.693 4.8172 16 5.16382 16 5.5914C16 6.01897 15.693 6.36559 15.3143 6.36559H0.685714C0.307005 6.36559 0 6.01897 0 5.5914ZM0 10.4086C0 9.98103 0.307005 9.63441 0.685714 9.63441H15.3143C15.693 9.63441 16 9.98103 16 10.4086C16 10.8362 15.693 11.1828 15.3143 11.1828H0.685714C0.307005 11.1828 0 10.8362 0 10.4086ZM0 15.2258C0 14.7982 0.307005 14.4516 0.685714 14.4516H15.3143C15.693 14.4516 16 14.7982 16 15.2258C16 15.6534 15.693 16 15.3143 16H0.685714C0.307005 16 0 15.6534 0 15.2258Z"
                fill="currentColor"
            />
        </BaseIcon>
    );
});
